<template>
    <div class="designeroption" :id="'radio--' + 'match_previous_or_future_project'" data-designer-component-id="match_previous_or_future_project">
        <h3>Is this order to match a previous or future project?</h3>
        <div class="radiooption stylesoption">
            <span>
              <label>
                <input type="radio" v-model="localMatchProject" :name="'radio--' + 'match_previous_or_future_project'" :value="77"/>
                No
              </label>
            </span>
            <span>
              <label>
                <input type="radio" v-model="localMatchProject" :name="'radio--' + 'match_previous_or_future_project'" :value="78"/>
                Yes
              </label>
            </span>
        </div>
        <div class="stylesoption" v-if="localMatchProject == 78">
            <div class="form-group">
                <label>Please enter the Job Number:</label>
                <input type="text" v-model="localTarget" id="match_previous_or_future_project_number" class="form-control">
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    emits: ['update:target', 'update:match_project'],
    props: {
        target: {
            default: ''
        },
        match_project: {
            default: 77,
        }
    },
    computed: {
        localMatchProject: {
            get() {
                return this.match_project
            },
            set(val) {
                if(this.match_project !== val) {
                    this.$emit('update:match_project', val)
                }
            }
        },
        localTarget: {
            get() {
                return this.target
            },
            set(val) {
                if(this.target !== val) {
                    this.$emit('update:target', val)
                }
            }
        },
    },
    watch: {
        localMatchProject: function () {
            if(this.localMatchProject != 78) {
                this.localTarget = null;
            }
        },
    },
}
</script>
